import React from "react";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";
import VolunteerActivismOutlinedIcon from "@mui/icons-material/VolunteerActivismOutlined";
import YardOutlinedIcon from "@mui/icons-material/YardOutlined";
import EnergySavingsLeafOutlinedIcon from "@mui/icons-material/EnergySavingsLeafOutlined";
import Diversity2TwoToneIcon from "@mui/icons-material/Diversity2TwoTone";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import FemaleOutlinedIcon from "@mui/icons-material/FemaleOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import SupportOutlinedIcon from "@mui/icons-material/SupportOutlined";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import Diversity1OutlinedIcon from "@mui/icons-material/Diversity1Outlined";
import AgricultureOutlinedIcon from "@mui/icons-material/AgricultureOutlined";
import ElderlyOutlinedIcon from "@mui/icons-material/ElderlyOutlined";
import TsunamiOutlinedIcon from "@mui/icons-material/TsunamiOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import BalanceOutlinedIcon from "@mui/icons-material/BalanceOutlined";
import VaccinesOutlinedIcon from "@mui/icons-material/VaccinesOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import MilitaryTechOutlinedIcon from "@mui/icons-material/MilitaryTechOutlined";
import RestaurantOutlinedIcon from "@mui/icons-material/RestaurantOutlined";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import ConnectWithoutContactOutlinedIcon from "@mui/icons-material/ConnectWithoutContactOutlined";
import MemoryOutlinedIcon from "@mui/icons-material/MemoryOutlined";
import SatelliteAltOutlinedIcon from "@mui/icons-material/SatelliteAltOutlined";
import ModelTrainingOutlinedIcon from "@mui/icons-material/ModelTrainingOutlined";
import BrushOutlinedIcon from "@mui/icons-material/BrushOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
// import { ReactComponent as ChildCareIcon } from "../../../assets/icons/child-care.svg";
// import { ReactComponent as CrueltyFreeIcon } from "../../../assets/icons/cruelty-free.svg";
// import { ReactComponent as LocationAwayIcon } from "../../../assets/icons/location-away.svg";
// import { ReactComponent as PaymentsIcon } from "../../../assets/icons/payments.svg";
// import { ReactComponent as OutpatientMedIcon } from "../../../assets/icons/outpatient-med.svg";
// import { ReactComponent as Diversity4Icon } from "../../../assets/icons/diversity-4.svg";
// import { ReactComponent as EcoIcon } from "../../../assets/icons/temp-preferences-eco.svg";

import { ComponentsHashType } from "store/types";
import {
  ChildCareIcon,
  CrueltyFreeIcon,
  Diversity4Icon,
  EcoIcon,
  LocationAwayIcon,
  OutpatientMedIcon,
  PaymentsIcon
} from "assets/material-custom-icons";
import { InterestType } from "store/types/user/social";

export const interests: ComponentsHashType<InterestType> = {
  [InterestType.SCHOOL]: SchoolOutlinedIcon,
  [InterestType.HEART]: MonitorHeartOutlinedIcon,
  [InterestType.VOLUNTEER]: VolunteerActivismOutlinedIcon,
  [InterestType.YARD]: YardOutlinedIcon,
  [InterestType.ENERGY]: EnergySavingsLeafOutlinedIcon,
  [InterestType.DIVERSITY2]: Diversity2TwoToneIcon,
  [InterestType.PALETTE]: PaletteOutlinedIcon,
  [InterestType.FEMALE]: FemaleOutlinedIcon,
  [InterestType.CHILD]: ChildCareIcon,
  [InterestType.HANDSHAKE]: HandshakeOutlinedIcon,
  [InterestType.SUPPORT]: SupportOutlinedIcon,
  [InterestType.CRUELTY]: CrueltyFreeIcon,
  [InterestType.BIOTECH]: BiotechOutlinedIcon,
  [InterestType.DIVERSITY1]: Diversity1OutlinedIcon,
  [InterestType.AGRICULTURE]: AgricultureOutlinedIcon,
  [InterestType.PAYMENTS]: PaymentsIcon,
  [InterestType.LOCATION]: LocationAwayIcon,
  [InterestType.ELDERLY]: ElderlyOutlinedIcon,
  [InterestType.TSUNAMI]: TsunamiOutlinedIcon,
  [InterestType.PSYCHOLOGY]: PsychologyOutlinedIcon,
  [InterestType.BALANCE]: BalanceOutlinedIcon,
  [InterestType.VACCINES]: VaccinesOutlinedIcon,
  [InterestType.PUBLIC]: PublicOutlinedIcon,
  [InterestType.MILITARY]: MilitaryTechOutlinedIcon,
  [InterestType.RESTAURANT]: RestaurantOutlinedIcon,
  [InterestType.TROPHY]: RestaurantOutlinedIcon,
  [InterestType.MEDICAL]: MedicalServicesOutlinedIcon,
  [InterestType.CONNECT]: ConnectWithoutContactOutlinedIcon,
  [InterestType.MEMORY]: MemoryOutlinedIcon,
  [InterestType.SATELLITE]: SatelliteAltOutlinedIcon,
  [InterestType.OUTPATIENT]: OutpatientMedIcon,
  [InterestType.MODEL]: ModelTrainingOutlinedIcon,
  [InterestType.BRUSH]: BrushOutlinedIcon,
  [InterestType.DIVERSITY4]: Diversity4Icon,
  [InterestType.ECO]: EcoIcon,
  [InterestType.FLAG]: FlagOutlinedIcon
};

export interface IInterestIconProps {
  type: InterestType;
  sx?: React.CSSProperties;
}

export const InterestIcon: React.FC<IInterestIconProps> = ({ type, sx }) => {
  const FileIcon = interests[type];

  const mergedStyles = { color: "#5dcbb7", fill: "#5dcbb7", ...sx };

  return <FileIcon sx={mergedStyles} />;
};
export { InterestType };
